import React, { useState } from 'react';
import { CgClose } from 'react-icons/cg';
import { MdStar, MdStarBorder } from 'react-icons/md';
import { firestore, firebase } from '../firebaseConfig';
import { usePopupManager } from './PopupManager';

const FeedbackPopup = () => {
  const { isActive, closePopup } = usePopupManager();
  const [rating, setRating] = useState(0);
  const [experience, setExperience] = useState('');
  const [improvements, setImprovements] = useState('');
  const [productRequests, setProductRequests] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (!isActive('feedback')) return null;

  const handleClose = () => {
    sessionStorage.setItem('feedbackShown', '1');
    closePopup('feedback');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) return;
    setLoading(true);
    try {
      await firestore.collection('feedback').add({
        rating,
        experience,
        improvements,
        productRequests,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        page: window.location.pathname,
      });
      setDone(true);
      sessionStorage.setItem('feedbackShown', '1');
      setTimeout(() => closePopup('feedback'), 1500);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 px-4">
      <div className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl p-6 text-left max-h-[90vh] overflow-y-auto">
        <button
          type="button"
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
          aria-label="Close"
        >
          <CgClose size={22} />
        </button>
        {done ? (
          <p className="text-center py-6 text-green-600 font-semibold">
            Thank you for your feedback!
          </p>
        ) : (
          <>
            <h2 className="text-xl font-bold text-gray-900 mb-1">How are we doing?</h2>
            <p className="text-sm text-gray-600 mb-4">Your feedback helps us improve Veth Interiors.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Rating</label>
                <div className="flex gap-1">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <button
                      key={n}
                      type="button"
                      onClick={() => setRating(n)}
                      className="text-amber-500 text-3xl"
                    >
                      {n <= rating ? <MdStar /> : <MdStarBorder />}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Experience</label>
                <textarea
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                  rows={2}
                  className="w-full border border-gray-300 rounded-lg p-3 text-sm outline-none focus:border-amber-500"
                  placeholder="How was your experience?"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Improvements</label>
                <textarea
                  value={improvements}
                  onChange={(e) => setImprovements(e.target.value)}
                  rows={2}
                  className="w-full border border-gray-300 rounded-lg p-3 text-sm outline-none focus:border-amber-500"
                  placeholder="What could we do better?"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Product requests</label>
                <textarea
                  value={productRequests}
                  onChange={(e) => setProductRequests(e.target.value)}
                  rows={2}
                  className="w-full border border-gray-300 rounded-lg p-3 text-sm outline-none focus:border-amber-500"
                  placeholder="Any products you'd like to see?"
                />
              </div>
              <button
                type="submit"
                disabled={loading || rating === 0}
                className="w-full py-3 bg-gradient-to-r from-amber-600 to-yellow-600 text-white font-bold rounded-full disabled:opacity-60"
              >
                {loading ? 'Submitting…' : 'Submit Feedback'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default FeedbackPopup;
